module.exports = __webpack_public_path__ + "img/4.1.93b2ed55.png";